function defer(method) {
    if (window.jQuery) {
    //alert("done")

        //jQuery(document).ready(function($) { });
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}



//$(window).load(function() {





//});
// without using jquery
// refreshes carousel for 7.4 triggers call that makes owl think the page is resized
window.onload = function () {
    console.log("first onload");
    defer(function () {

        //adds support for IE with the SVG thing, because ie/edge is special
        svg4everybody();
        $('.aoc-top-nav__nav--mobile').click(function() {
            $('.aoc-top-nav').toggleClass('make-visible');
        });
        //adds mobile nav toggle
        $('#aoc-calendar').fullCalendar('option', 'locale', calendarLocale);
    });
    window.dispatchEvent(new Event('resize'));
};


// for adjustments to content carousels

let image_url, image, imgWid, tempStyles;

function rotateOImg() {
    $(".aoc-slider__img-mobile").each(function(){

        //console.log($(this).attr("data-src"));
        image_url = $(this).attr("data-src");
        image=new Image();
        image.src = image_url;
        // if owl slider messes up and gives null for background image, apply daa-src attribute
        if($(this).attr("style") == 'background-image: url("");') {
            $(this).attr("style","background-image: url("+$(this).attr("data-src") +")");
        }
        daratio=image.height / image.width;
        imgWid=$(".aoc-slider.owl-carousel.aoc-slider-js.aoc-content-aware-slider.owl-loaded.owl-drag .owl-item").width();
        imgHid=$(".aoc-slider.owl-carousel.aoc-slider-js.aoc-content-aware-slider.owl-loaded.owl-drag .owl-item").height();

        //console.log(imgHid * daratio);
        //console.log($("body").width());
        //$(".aoc-slider.owl-carousel.aoc-slider-js.aoc-content-aware-slider.owl-loaded.owl-drag").height(imgWid * daratio+"px");


            tempStyles='@media screen and (max-width: 1329px) {.aui #aoc .aoc-slider.aoc-content-aware-slider {max-height:'+((imgWid * daratio) + 2)+'px!important;}} @media screen and (max-width: 520px) {.aui #aoc .aoc-slider.aoc-content-aware-slider {max-height:'+ ((imgWid * daratio) + 117)+'px!important;}}';



    });
    var styles1 = $('<style id="fixSlider"></style>');

    $("body").append(styles1);
    try{
    //console.log(tempStyles);
    $("#fixSlider").html(tempStyles);
    }catch(e){alert(e.message)}
}


window.onload = function () {

    //alert($(".aoc-slider.owl-carousel.aoc-slider-js").hasClass("aoc-content-aware-slider")+" "+ $(".aoc-slider.owl-carousel.aoc-slider-js").attr("class"));
    if($(".aoc-slider.aoc-slider-js").hasClass("owl-carousel") == true && $(".aoc-slider.owl-carousel.aoc-slider-js").hasClass("aoc-content-aware-slider") == false){
       // force resize of window event to address owl slider not going full width
        window.dispatchEvent(new Event('resize'));
    }

    if($(".aoc-slider.owl-carousel.aoc-slider-js").hasClass("aoc-content-aware-slider") == true){

        //updates heights for content slider after load
        setTimeout(function(){
            rotateOImg();  window.dispatchEvent(new Event('resize'));
        }, 2000);
        // force resize of window event to address owl slider not going full width
        window.dispatchEvent(new Event('resize'));
        //update heights on window resize
        $(window).resize(function(){
            rotateOImg();
        });
    }

    $(".aoc-sidenav__item.dropdown").click(function(){
        //$(this).toggleClass("toggleStateClick");
    });

    $(".lfr-nav-child-toggle").unbind("click").click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().parent().parent().toggleClass("toggleStateClick");
        $(this).toggleClass("rotateArrow");
    });

}

